export let themeColors = {
  ColorPrimary: '#317773',
  ColorSecondary: '#fcffff',
};
